import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { updateCurrentSessionUser } from '@client/slices/helpers/session.reducer';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import { ProfileTypes } from '@sda/enums';
import { getDateTime } from '@sda/utils/date';
import type { PendingProfile } from '@sda/interfaces/profile';
import type { ExtendedUser } from '@sda/interfaces/reducer/session.reducer';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const profileAdapter = createEntityAdapter<PendingProfile & FetchDataType>({
  sortComparer: (a, b) => getDateTime(b.createdAt).toMillis() - getDateTime(a.createdAt).toMillis(),
});

interface ProfileState {
  readonly selectedProfileId: string;
}

const initialState: ProfileState = {
  selectedProfileId: null,
};

const profilesSlice = createSlice({
  initialState: profileAdapter.getInitialState<ProfileState>(initialState),
  name: Reducers.PROFILES,
  reducers: {
    ...extractSharedActions(profileAdapter),
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCurrentSessionUser, (state, action: PayloadAction<ExtendedUser>) => {
        if (action.payload?.selectedProfileId) {
          state.selectedProfileId = action.payload?.selectedProfileType === ProfileTypes.PENDING ? action.payload.selectedProfileId : null;
        }
      });
  },
});

export const {
  upsertOne: upsertProfile, updateOne: updateProfile, upsertMany: upsertProfiles,
} = profilesSlice.actions;

export default profilesSlice.reducer;
